import * as React from 'react'
import style from './FloatingSearchButton.module.css'
import SearchListIcon from './search-menu-icon.svg'

export enum Variants {
  MINI = 'mini'
}

export interface FloatingSearchButtonProps {
  variant?: Variants
}

export const FloatingSearchButton = ({
  variant
}: FloatingSearchButtonProps) => {
  const sharedButtonStyle =
    'h-12 font-semibold text-center bg-white border-2 border-solid rounded-lg shadow-md text-oo-primary-75 border-oo-primary-75'
  const sharedIconStyle = 'mb-1 align-middle fill-current stroke-current'

  if (variant === Variants.MINI) {
    return (
      <button
        className={`z-50 px-3 ml-4 ${sharedButtonStyle}`}
        data-testid='floating-search-button-mini'
      >
        <SearchListIcon
          className={`${sharedIconStyle} ${style.searchButtonSvg}`}
        />
      </button>
    )
  }
  // default to full width button with text unless mini variant specified
  return (
    <div className='fixed bottom-0 z-50 flex justify-center w-full mb-5'>
      <button
        data-testid='floating-search-button-full'
        className={`px-4 ${sharedButtonStyle}`}
      >
        <SearchListIcon
          className={`mr-2 ${sharedIconStyle} ${style.searchButtonSvg}`}
        />
        <span>Explore the menu</span>
      </button>
    </div>
  )
}
